import { ChatResponse } from '../chat-response.model';

export class DefaultAdapter implements ChatResponse {
  getFormattedResponse(data: { summary?: string }): Record<string, any> {
    return {
      type: 'text',
      content: data.summary ?? "Sorry, I couldn't find any data related to your request.",
    };
  }
}
